// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2el2p","label":"Section_label__267A-","contentWrap":"Section_contentWrap__5qxRk","footer":"Section_footer__3A7c0","footerInner":"Section_footerInner__1Ktuq"};